import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { Link } from 'react-router-dom';
import { newI18n } from '../core/Const';
export interface Homesection4Props extends BaseComponentProps {
}
export interface Homesection4State extends BaseComponentState { }
export class Homesection4 extends BaseComponent<Homesection4Props, Homesection4State> {

	translation = {
		Title: newI18n("HOME.HOMESECTION4.Title", "The Ultimate Bali Experience at Your Fingertips"),
		SubTitle: newI18n("HOME.HOMESECTION4.SubTitle", " ")
	};

	renderisi(key: string, image: string, slug: string, target: string, linkType: string) {
		let ret = (
			<Link to={slug} target={target}>
				<img src={image} className="img-responsive" />
			</Link>
		);
		if (linkType === 'a') {
			ret = (
				<a href={slug} target={target}>
					<img src={image} className="img-responsive" />
				</a>
			);
		}
		return (
			<div key={key} style={{ padding: 10 }} className="col-md-4 ">
				<div className="figure-wrapper">
					<figure className="effect-zoe">
						{ret}
					</figure>
				</div>
			</div>
		);

	}
	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		return (
			<section className="container-fluid container-fullw" data-stellar-background-ratio="0.5"  >
				<div className="container">
					<div className="row">
						<h3 style={{ textAlign: 'center', marginBottom: 30 }}>{this.translation.Title}</h3>
						<hr/>
						<h4 style={{ textAlign: 'center', marginBottom: 30 }}> {this.translation.SubTitle}</h4>
						{this.renderisi('about', 'https://storage.googleapis.com/bali-hotel-images/SignUpHotelBanner.jpg', '/about-us', '', 'link')}
						{this.renderisi('tour', 'https://storage.googleapis.com/bali-hotel-images/GetUpTo30PercentOffBanner.jpg', 'https://www.balitoursandmore.com/bali-super-pass/', '_blank', 'a')}
						{this.renderisi('villa', 'https://storage.googleapis.com/bali-hotel-images/Over-200-Private-Villa-Front-Page-Banner.jpg', 'https://www.balivillasandmore.com/', '_blank', 'a')}
					</div>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/home/Homesection4.tsx